<template>
  <div class="pulmonary-section">
    <span class="accordion-title">
      {{ $t("accordion_pulmonary_title") }}
    </span>
    <AccordionVideoContainer
      :videoIds="['655291545', '605506367', '354817258', '244346791']"
    />
    <ListWithArrows
      :entriesLeft="[
        'accordion_pulmonary_arrow_list_1',
        'accordion_pulmonary_arrow_list_2',
        'accordion_pulmonary_arrow_list_3',
      ]"
      :entriesRight="[
        'accordion_pulmonary_arrow_list_4',
        'accordion_pulmonary_arrow_list_5',
      ]"
    />
    <ScientificInformationCardRow :count="3" prefix="accordion_pulmonary" />
    <ProductsForIntervention
      :leftItems="['20402-411', '20402-410', '20402-401', '20402-402']"
      :leftInformation="[]"
      :leftButtonLink="
        'https://de.erbe-med.com/productfinder/index.php?openurl=PLM_PRODUKTKATEGORIE%3DInstrument%7CPLM_PRODUKTGRUPPE%3DFlexible%20Sonden%7CPLM_PRODUKTUNTERGRUPPE%3DERBECRYO%202&language=en'
      "
      :rightItems="['20132-220', '20132-221']"
      :rightInformation="[
        'accordion_pulmonary_products_information_1',
        'accordion_pulmonary_products_information_2',
        'accordion_pulmonary_products_information_3',
      ]"
      :rightButtonLink="
        'https://de.erbe-med.com/productfinder/index.php?openurl=PLM_PRODUKTKATEGORIE%3DInstrument%7CPLM_PRODUKTGRUPPE%3DFlexible%20Sonden%7CPLM_PRODUKTUNTERGRUPPE%3DFiAPC&language=en'
      "
    />
  </div>
</template>

<script>
import ScientificInformationCardRow from "@/components/ScientificInformationCardRow";
import ListWithArrows from "../../components/ListWithArrows.vue";
import AccordionVideoContainer from "../../components/AccordionVideoContainer.vue";
import ProductsForIntervention from "../../components/ProductsForIntervention.vue";

export default {
  name: "PulmonarySection",
  components: {
    ScientificInformationCardRow,
    ListWithArrows,
    AccordionVideoContainer,
    ProductsForIntervention,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss";
.pulmonary-section {
  display: flex;
  flex-direction: column;
  font-family: $font_nettoRegular;
  background-color: lightgray;
  background: -webkit-radial-gradient(circle center 50%, lightgray, gray);
  background: radial-gradient(circle at center 50%, lightgray, gray);
  align-items: center;
  cursor: default;
  padding-top: 1rem;
}
</style>
